/* eslint-disable */
export default {
  noActiveCalls: 'No hay llamadas activas',
  noCalls: 'No hay resultados.',
  currentCall: 'Llamada actual',
  ringCall: 'Llamada sonando',
  onHoldCall: 'Llamada en espera',
  historyCalls: 'Llamadas anteriores',
  otherDeviceCall: 'Llamadas en curso en mis otros dispositivos',
  searchPlaceholder: 'Buscar…',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
